import { GiftCreatePage } from './GiftCreatePage'

export default GiftCreatePage
// eslint-disable-next-line import/export
export * from './GiftCreatePage'
